import { AuthorizationService } from '@services';

interface SRef<T> {
  current: T;
}

const services : Record<string, AuthorizationService> = {};

export const useServiceRef = <T extends AuthorizationService>(
  Service: {
    serviceName: string,
    new (): T
  }
): SRef<T> => {
  const serviceRef = { current: null };

  if (services[Service.serviceName]) {
    serviceRef.current = services[Service.serviceName];
  } else {
    services[Service.serviceName] = new Service();
    serviceRef.current = services[Service.serviceName];
  }

  return serviceRef;
};
